function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 2.668C0 1.194 1.178 0 2.621 0h8.472c1.444 0 2.621 1.199 2.621 2.668v1.727a.524.524 0 0 1-.519.529.524.524 0 0 1-.52-.529V2.668c0-.89-.712-1.615-1.586-1.615H2.62c-.873 0-1.587.726-1.587 1.615v10.664c0 .89.714 1.615 1.587 1.615h8.464c.873 0 1.587-.726 1.587-1.615v-1.727c0-.292.232-.529.519-.529.287 0 .52.237.52.529v1.727c0 1.47-1.179 2.668-2.622 2.668H2.62C1.178 16 0 14.801 0 13.332V2.668zm8.82 9.182a.494.494 0 0 1 0-.715l2.682-2.621H3.524A.517.517 0 0 1 3 8.002c0-.283.234-.512.524-.512h7.982L8.824 4.87a.5.5 0 0 1 0-.72c.204-.2.532-.2.737 0l3.571 3.49a.5.5 0 0 1 0 .72l-3.571 3.49a.525.525 0 0 1-.37.15.525.525 0 0 1-.371-.15z"
});

var SvgIconLogout = function SvgIconLogout(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-logout.dc96cbd6.svg";
export { ForwardRef as ReactComponent };